import {
  API_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAIL,
  CHANGE_PASSWORD_RESET,
  CHANGE_PASSWORD_SUCCESS,
  LOGIN_SUCCESS,
  LOGIN_USER,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  changePasswordData: {
    loading: false,
    data: null,
    error: null,
  },
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    case LOGOUT_USER:
      state = { ...state };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state };
      break;
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    // Change password
    case CHANGE_PASSWORD:
      state = {
        ...state,
        changePasswordData: {
          loading: true,
          data: null,
          error: null,
        },
        type: action.type,
      };
      break;
    case CHANGE_PASSWORD_SUCCESS:
      state = {
        ...state,
        changePasswordData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
      break;
    case CHANGE_PASSWORD_FAIL:
      state = {
        ...state,
        changePasswordData: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
      break;
    case CHANGE_PASSWORD_RESET:
      state = {
        ...state,
        changePasswordData: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
